export default function AdminPageSessionClose() {
    
    let ParesentStatus = sessionStorage.getItem("CompanyMenuBranchUserActive");
    
    if(ParesentStatus === "true"){
        sessionStorage.setItem("CompanyMenuBranchUserActive", "false");
    };
};
